import React from "react";
import {Modal, Button, Typography} from "antd";

import {i18, trb} from "../../Utilities";

export const UnauthorizedCompanyModal = ({onCancel}) => {
    return (
        <Modal
            width={520}
            footer={[
                <Button size="large" type="ghost" onClick={onCancel} className="unauthorized-company-btn">
                    {trb(i18.Buttons.Cancel)}
                </Button>
            ]}
            title={trb(i18.ModalTitles.NoAuthorizedCompany)}
            centered
            visible
            closable={false}
            onCancel={onCancel}
        >
            <div className="text-center">
                <Typography.Text>{trb(i18.Labels.NoAuthorizedCompanyDescription)}</Typography.Text>
            </div>
        </Modal>
    );
};
